import { HttpClient } from '@/shared/lib/http-client';

export const fetchTaskById = async (taskId) => {
  const response = await HttpClient.get('/tasks', {
    task_id: taskId,
  });

  return response.data?.data;
};
